module.exports = __webpack_public_path__ + "img/hand.8ce91375.png";